import { render, staticRenderFns } from "./ChooseMethod.vue?vue&type=template&id=4670b770&scoped=true"
import script from "./ChooseMethod.vue?vue&type=script&lang=js"
export * from "./ChooseMethod.vue?vue&type=script&lang=js"
import style0 from "./ChooseMethod.vue?vue&type=style&index=0&id=4670b770&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4670b770",
  null
  
)

export default component.exports